import {
  NR01CreateStockGruppeResponse,
  NR01DeleteStockGruppeResponse,
  NR01StockGruppeResponse,
  NR01UpdateStockGruppeResponse,
} from '../../models/NR01StockGruppeOverview';
import * as actionTypesNR01 from '../actions/actionTypesNR01';
import * as fromApp from '../rootReducer';

export interface FeatureState extends fromApp.AppState {
  state: NR01State;
}

export interface NR01State {
  data: NR01StockGruppeResponse | null;
  deleteResult: NR01DeleteStockGruppeResponse | null;
  createResult: NR01CreateStockGruppeResponse | null;
  updateResult: NR01UpdateStockGruppeResponse | null;
  error: any;
  isFetching: boolean;
  isLoadingMore: boolean;
  isDeleting: boolean;
  isCreating: boolean;
  isUpdating: boolean;
}

const initialState: NR01State = {
  data: null,
  deleteResult: null,
  createResult: null,
  updateResult: null,
  error: undefined,
  isFetching: false,
  isLoadingMore: false,
  isDeleting: false,
  isCreating: false,
  isUpdating: false,
};

const NR01Reducer = (state = initialState, action: any): NR01State => {
  switch (action.type) {
    case actionTypesNR01.NR01_STOCKGRUPPE_GET:
      return {
        ...state,
        isFetching: true,
        error: undefined,
      };
    case actionTypesNR01.NR01_STOCKGRUPPE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isFetching: false,
        error: undefined,
      };
    case actionTypesNR01.NR01_STOCKGRUPPE_LOAD_MORE:
      return {
        ...state,
        isLoadingMore: true,
        error: undefined,
      };
    case actionTypesNR01.NR01_STOCKGRUPPE_LOAD_MORE_SUCCESS:
      // The next page is added after the rows already shown.
      return {
        ...state,
        data: state.data
          ? { ...action.payload, content: [...state.data.content, ...action.payload.content] }
          : action.payload,
        isLoadingMore: false,
        error: undefined,
      };
    case actionTypesNR01.NR01_STOCKGRUPPE_LOAD_MORE_FAILURE:
      return {
        ...state,
        isLoadingMore: false,
        error: action.payload,
      };
    case actionTypesNR01.NR01_STOCKGRUPPE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    case actionTypesNR01.NR01_STOCKGRUPPE_DELETE:
      return {
        ...state,
        isDeleting: true,
        error: undefined,
      };
    case actionTypesNR01.NR01_STOCKGRUPPE_DELETE_SUCCESS:
      return {
        ...state,
        deleteResult: action.payload,
        isDeleting: false,
        error: undefined,
      };
    case actionTypesNR01.NR01_STOCKGRUPPE_DELETE_FAILURE:
      return {
        ...state,
        isDeleting: false,
        error: action.payload,
      };
    case actionTypesNR01.NR01_STOCKGRUPPE_CREATE:
      return {
        ...state,
        isCreating: true,
        error: undefined,
      };
    case actionTypesNR01.NR01_STOCKGRUPPE_CREATE_SUCCESS:
      return {
        ...state,
        createResult: action.payload,
        isCreating: false,
        error: undefined,
      };
    case actionTypesNR01.NR01_STOCKGRUPPE_CREATE_FAILURE:
      return {
        ...state,
        isCreating: false,
        error: action.payload,
      };
    case actionTypesNR01.NR01_STOCKGRUPPE_UPDATE:
      return {
        ...state,
        isUpdating: true,
        error: undefined,
      };
    case actionTypesNR01.NR01_STOCKGRUPPE_UPDATE_SUCCESS:
      return {
        ...state,
        updateResult: action.payload,
        isUpdating: false,
        error: undefined,
      };
    case actionTypesNR01.NR01_STOCKGRUPPE_UPDATE_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.payload,
      };
    case actionTypesNR01.NR01_RESET:
      return initialState;
    default:
      return state;
  }
};

export default NR01Reducer;
